import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Caixa } from 'src/app/base/domain/caixa.model';
import { CardListComponent } from '../../components/card-list/card-list.component';
import { NgForm } from '@angular/forms';
import { Table } from 'primeng/table';
import { QueryOptions } from '../../domain/query.options';
import { ReturnAPI, Page } from 'src/app/base/domain/return-api.model';
import { LazyLoadEvent } from 'primeng/api';
import { SituacaoCaixa } from 'src/app/base/domain/enum/situacao-caixa.enum';
import { Posto } from 'src/app/base/domain/posto.model';
import { Funcionario } from 'src/app/base/domain/funcionario.model';
import { FuncionarioService } from 'src/app/base/services/funcionario.service';

export interface CaixaListFilterOptions {
  nomeFuncionario: string;
  situacaoCaixa: SituacaoCaixa[];
  postoSelecionado: Posto;
  fiscalSelecionado: Funcionario;
  dataInicial: Date;
  dataFinal: Date;
}

export interface CaixaAcaoEvent {
  acao: string;
  caixa: Caixa;
}

@Component({
  selector: 'app-caixa-list',
  templateUrl: './caixa-list.component.html',
  styleUrls: ['./caixa-list.component.css'],
})
export class CaixaListComponent implements OnInit {

  @ViewChild('searchForm', { static: false }) searchForm: NgForm;
  @ViewChild('dataTable', { static: false }) dataTable: Table;
  @ViewChild(CardListComponent, { static: true }) cardList: CardListComponent;

  fiscais: Funcionario[] = [];

  @Input() title: string;
  @Input() caixas: Page<Caixa>;
  @Input() type: string;
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() loading: boolean;
  @Input() filtros: string[];
  @Input() optionalColumns: string[];
  @Input() options: string[];
  @Input() menuAcoes: string[];

  @Output() filter = new EventEmitter<CaixaListFilterOptions>();
  @Output() loadCaixasPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<CaixaAcaoEvent>();

  private currentPage = 0;
  queryOptions = new QueryOptions();

  private readonly defaultFilterOptions: CaixaListFilterOptions = {
    nomeFuncionario: '',
    situacaoCaixa: [],
    postoSelecionado: null,
    fiscalSelecionado: null,
    dataInicial: null,
    dataFinal: null,
  };

  filterOptions: CaixaListFilterOptions;

  situacoes: SituacaoCaixa[] = Object.values(SituacaoCaixa);

  constructor(
    private funcionarioService: FuncionarioService,
  ) {
    this.onLimparFiltros();
  }

  ngOnInit(): void {

  }

  onAcaoClick(acao: string, domain: Caixa): void {
    this.acaoClick.emit({ acao, caixa: domain });
  }

  onMenuAcaoClick(event: string): void {
    const novoCaixa = new Caixa();
    this.onAcaoClick(event, novoCaixa);
  }

  loadCaixas(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadCaixasPage.emit(pageNumber);
  }

  listarFiscalPorPosto(posto: Posto): void {
    this.funcionarioService.listFuncionarioByCargoAndPosto(7, posto.id).subscribe((response: ReturnAPI<Funcionario[]>) => {
      if (response.success) {
        this.fiscais = response.object;
      }
    });
  }

  onLimparFiltros(): void {
    this.filterOptions = Object.assign({}, this.defaultFilterOptions);
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }

  onAtualizar(): void {
    this.loadCaixasPage.emit(this.currentPage);
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
}

